import $ from 'jquery';

function addModalHandlers() {
  $('.delete-account').on('click', () => {
    $('#confirmation_dialog').show();
    $('.modal-backdrop').show();
    $('#confirmation_dialog').css('opacity', 1);
  });

  $('#confirmation_dialog .cancel').on('click', () => {
    $('#confirmation_dialog').hide();
    $('.modal-backdrop').hide();
    $('#confirmation_dialog').css('opacity', 0);
  });
}

$(() => {
  addModalHandlers();
});

document.addEventListener('page:change', () => {
  addModalHandlers();
});
